const pt = {
  cnpj: 'CNPJ',
  cpf: 'CPF',
  fullName: 'Nome completo',
  businessName: 'Razão social',
  email: 'E-mail',
  phoneNumber: 'Telefone',
  accountVerification: {
    form: {
      title: 'Cadastre seus dados bancários',
      subtitle: 'Para começar a vender dentro da plataforma, precisamos verificar suas informações pessoais e seus dados bancários.',
      modality: {
        label: 'Modalidade',
        tooltip: 'Modalidade de conta em que todas as vendas na plataforma será processada.',
        cpf: 'Pessoa física (CPF)',
        cnpj: 'Pessoa jurídica (CNPJ)'
      },
      cpf: {
        label: 'Dados do titular da conta',
        tooltip: 'Responsável e proprietário legal da conta bancária cadastrada.'
      },
      cnpj: {
        companyLabel: 'Dados da empresa',
        ownerLabel: 'Dados do administrador da empresa',
        tooltip: 'Responsável pela empresa, devendo estar autorizado a representar a empresa conforme quadro societário.'
      },
      bankAccount: {
        title: 'Dados bancários',
        subtitle: 'Registre uma conta bancária para receber seu faturamento. Lembrando que os dados da conta bancária cadastrada devem ser da mesma titularidade cadastrada acima.',
        bank: 'Banco',
        agency: 'Agência',
        agencyDigit: 'Dígito',
        account: 'Conta',
        accountDigit: 'Dígito',
        accountType: 'Tipo de conta',
        types: {
          0: 'Não especificado',
          1: 'Conta corrente',
          2: 'Conta poupança'
        }
      },
      billingAddress: {
        title: 'Endereço de cobrança',
        number: 'Número',
        complement: 'Complemento',
        street: 'Rua',
        postalCode: 'CEP',
        city: 'Cidade',
        state: 'Estado',
        neighborhood: 'Bairro'
      },
      pixKey: {
        title: 'Chave Pix',
        subtitle: 'Para saques na modalidade Pix, utilizaremos como chave o mesmo documento informado nos dados do titular da conta.'
      },
      close: 'Fechar',
      submit: 'Cadastrar'
    }
  },
  accountVerificationBanner: {
    close: 'Fechar',
    title: 'Cadastre seus dados bancários para começar a vender na plataforma.',
    cta: 'Cadastrar dados bancários'
  },
  updateAccount: {
    title: 'Alterar dados bancários',
    cpf: {
      label: 'Dados do titular da conta',
      tooltip: 'Responsável e proprietário legal da conta bancária cadastrada.'
    },
    cnpj: {
      label: 'Dados do administrador da empresa',
      tooltip: 'Responsável pela empresa, devendo estar autorizado a representar a empresa conforme quadro societário.'
    },
    submit: 'Alterar dados bancários'
  },
  confirmationModal: {
    create: {
      title: 'Cadastre seus dados bancários para começar a vender',
      message: 'Para começar a vender dentro da plataforma, precisamos verificar suas informações pessoais e seus dados bancários.',
      cancel: 'Talvez mais tarde',
      confirm: 'Cadastrar dados bancários'
    },
    update: {
      title: 'Verifique suas informações para realizar saques na plataforma',
      message: 'Identificamos erros nos dados bancários cadastrados, por favor atualize seus dados bancários para realizar saques.',
      cancel: 'Talvez mais tarde',
      confirm: 'Atualizar dados bancários'
    }
  },
  roleplayModal: {
    create: {
      title: 'O administrador da conta ainda não verificou as informações bancárias',
      message: 'Entre em contato com o administrador da conta antes de tentar realizar essa ação.',
      cancel: 'Fechar'
    },
    update: {
      title: 'Os dados bancários do administrador da conta ainda não foram aprovados',
      message: 'Entre em contato com o administrador da conta antes de tentar realizar essa ação.',
      cancel: 'Fechar'
    }
  },
  documentTypeEnum: {
    0: 'Não especificado',
    1: 'CNPJ',
    2: 'CPF',
    3: 'Passaporte',
    100: 'Não declarado'
  },
  errors: {
    required: 'Campo obrigatório',
    invalidCpf: 'CPF inválido',
    invalidCnpj: 'CNPJ inválido',
    invalidEmail: 'E-mail inválido',
    invalidPhoneNumber: 'Telefone inválido',
    invalidFullName: 'Nome precisa ser completo',
    invalidBankAccount: 'Conta bancária inválida',
    invalidAgency: 'Agência inválida',
    invalidAgencyCheckNumber: 'Dígito da agência inválido',
    invalidAccount: 'Conta inválida',
    invalidAccountType: 'Tipo de conta inválido',
    invalidAccountCheckNumber: 'Dígito da conta inválido',
    invalidBank: 'Banco inválido',
    general: 'Ocorreu um erro, tente novamente mais tarde.',
    'not-found': 'A conta bancária informada não existe.',
    'different-ownership': 'A conta informada não é da mesma titularidade cadastrada.',
    'different-ownership-cnpj': 'A conta informada não é da mesma titularidade do CNPJ cadastrado.'
  },
  success: 'Dados bancários cadastrados com sucesso!'
};

export { pt };
